/**
 * WordPress dependencies
 */
import { Button, ButtonGroup } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

const defaultTabOptions = [
    {
        label: __('Normal', 'faqmate-blocks'),
        value: 'normal'
    },
    {
        label: __('Hover', 'faqmate-blocks'),
        value: 'hover'
    }
];

const DynamicSwitcher = ({ options = [], className = '', contentMap = {} }) => {
    const [tab, setTab] = useState(options.length > 0 ? options[0].value : defaultTabOptions[0].value);

    // Use provided options or fall back to default
    const Tabs = options.length > 0 ? options : defaultTabOptions;

    return (
        <div className={classNames('faqmate-control-container', 'faqmate-switcher', 'faqmate-mb-24', className)}>
            <ButtonGroup>
                {Tabs.map((item, index) => (
                    <Button
                        key={index}
                        className={`switcher-button ${tab === item.value ? 'faqmate-active' : ''}`}
                        onClick={() => setTab(item.value)}
                    >
                        {item.label}
                    </Button>
                ))}
            </ButtonGroup>
            <div className="faqmate-switcher-content">
                {Tabs.map(
                    (item, index) =>
                        tab === item.value && (
                            <div key={index} className={`faqmate-${item.value}-content`}>
                                {contentMap[item.value] || <div>{`Content for ${item.label}`}</div>}
                            </div>
                        )
                )}
            </div>
        </div>
    );
};

export default DynamicSwitcher;
